import discount from "../../assets/images/discount 1.svg";
import { ProductCard } from "./product-card";

const OfferList = ({ offers }) => {
  const productOffers = offers?.map((offer) => offer.products).flat();

  return (
    <div className="container-product">
      {productOffers && productOffers?.length > 0 ? (
        productOffers?.map((offer, index) => {
          const isLast = index === productOffers.length - 1;
          return <ProductCard product={offer} key={offer.id} isLast={isLast} isOffer={true}/>;
        })
      ) : (
        <div className="no-data">
          <img src={discount} alt="discount" />
          <h6>لايوجد عروض</h6>
        </div>
      )}
    </div>
  );
};

export default OfferList;
